var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"psi"}},[(_vm.initialized)?_c('auth-layout'):_c('psi-app-loader')],1)}
var staticRenderFns = []

export { render, staticRenderFns }